"use strict";function onRecordEnd$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.onRecordEnd$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="device.audio.onRecordEnd";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"2.8.0"},_a[ddSdk_1.ENV_ENUM.android]={vs:"2.8.0"},_a)),exports.onRecordEnd$=onRecordEnd$,exports.default=onRecordEnd$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/device/audio/onRecordEnd.js
// module id = 1043
// module chunks = 106